//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import StockControlledToolDepartments from './StockControlledToolDepartments.vue'
import { axiosGet } from '../../../../axios/axios.js'

export default {
  name: 'StockControlledToolDepartmentsDropdown',
  components: {
    StockControlledToolDepartments
  },
  props: {
    tool: {
      type: Object,
      required: true
    },
    filterByStocks: {
      type: Boolean,
      default: false
    },
    cached: {
      type: Boolean,
      default: false
    }
  },
  data: function () {
    return {
      loading: false,
      loaded: false,
      stocksAmounts: []
    }
  },
  methods: {
    onLoadToolStocksAmounts: function () {
      if (!this.loaded || !this.cached) {
        this.stocksAmounts = []
        this.loadToolStocksAmounts().then(() => {
          this.loaded = true
        })
      }
    },
    loadToolStocksAmounts: function () {
      const urlParams = new URLSearchParams()
      urlParams.set('toolId', this.tool.id)
      if (this.filterByStocks) {
        urlParams.set('filterByStocks', true)
      }

      this.loading = true
      return axiosGet({
        url: 'service/delta/stock/control/toolStocksAmounts?' + urlParams.toString(),
        onSuccess: (response) => {
          this.stocksAmounts = response.data.result || []
        },
        onFailure: (response) => {
          this.$q.notify({
            type: 'negative',
            message: response.message || 'Ошибка получения остатков на складах',
            progress: true,
            timeout: 10000
          })

          return Promise.reject(response.message)
        }
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
